import { SvgIcon } from '@mui/material';

const WorldwideService = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_169' data-name='Group 169' transform='translate(-354 -342)'>
      <circle
        id='Ellipse_3'
        data-name='Ellipse 3'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(354 342)'
        fill='#fff'
      />
      <g
        id='Group_152'
        data-name='Group 152'
        transform='translate(327.719 315.704)'
      >
        <path
          id='Path_77'
          data-name='Path 77'
          d='M266.224,473.874l-.024,0a.026.026,0,0,0,.024,0Z'
          transform='translate(-227.095 -428.464)'
          fill='#dc0132'
        />
        <path
          id='Path_78'
          data-name='Path 78'
          d='M308.4,176.357a.167.167,0,0,0-.324-.019.167.167,0,0,1-.159.117h-.469a.166.166,0,0,1-.086-.024l-.679-.407a.166.166,0,0,0-.086-.024h-1.086a.166.166,0,0,0-.093.028l-1.339.893a.167.167,0,0,0-.075.141v1.266a.167.167,0,0,0,.089.148l1.756.937a.168.168,0,0,1,.089.146l.008.713a.168.168,0,0,0,.086.144l.706.39a.168.168,0,0,1,.086.147v1.474a.167.167,0,0,0,.278.126,9.368,9.368,0,0,0,.747-.7q.135-.208.253-.427a6.291,6.291,0,0,0,.413-.941A9.862,9.862,0,0,0,308.4,176.357Z'
          transform='translate(-263.748 -139.631)'
          fill='#dc0132'
        />
        <path
          id='Path_79'
          data-name='Path 79'
          d='M66.224,74.785l-1.861-1.4a.121.121,0,0,0-.073-.024h-.883a.115.115,0,0,1-.081-.034l-.416-.416a.121.121,0,0,0-.086-.035H61.211a.115.115,0,0,1-.081-.2l.255-.255a.115.115,0,0,1,.081-.034h.982a.243.243,0,0,0,.234-.177l.209-.743a.121.121,0,0,1,.061-.075l.833-.429a.115.115,0,0,0,.062-.1v-.379a.116.116,0,0,1,.021-.066l.443-.638a.114.114,0,0,1,.054-.042l.62-.233a.115.115,0,0,0,.075-.108v-.346a.115.115,0,0,0-.051-.1l-.621-.413a.116.116,0,0,0-.116-.007l-.846.423a.115.115,0,0,1-.121-.012l-.4-.317a.115.115,0,0,1,0-.182l.326-.24a.115.115,0,0,0,0-.187l-.508-.354a.115.115,0,0,0-.121-.007c-.184.1-.722.4-.913.532a6.355,6.355,0,0,0-2.068,2.427.976.976,0,0,0-.13.356,2.669,2.669,0,0,1-.146.518.115.115,0,0,0,.007.094l1.083,1.99a.113.113,0,0,0,.042.044l1.139.684a.115.115,0,0,1,.055.083l.228,1.655a.116.116,0,0,0,.049.079l.889.611a.121.121,0,0,1,.05.075l.471,2.239a.109.109,0,0,0,.015.037c.044.072.221.334.434.373-.02.005-.037.018-.057.024a1.444,1.444,0,0,1,.152.035c.061.016.121.03.182.043.095.019.1.033.15-.051a.3.3,0,0,1,.182-.166.117.117,0,0,0,.088-.088l.306-1.416a.121.121,0,0,1,.049-.073L66.22,76.8a.121.121,0,0,0,.051-.1V74.882A.121.121,0,0,0,66.224,74.785Z'
          transform='translate(-26.506 -34.569)'
          fill='#dc0132'
        />
        <path
          id='Path_80'
          data-name='Path 80'
          d='M184.873,48l-.133.007q-.247.007-.492.034a6.294,6.294,0,0,0-1.735.444c.074.051-.053.1-.053.1l.2.388h1.062l.728.364.637-.364Z'
          transform='translate(-145.895 -15.515)'
          fill='#dc0132'
        />
        <path
          id='Path_81'
          data-name='Path 81'
          d='M337.669,91.207l.489-.425a.121.121,0,0,0-.029-.2l-.571-.265a.121.121,0,0,0-.161.058l-.235.492a.121.121,0,0,0,.045.155l.317.2A.121.121,0,0,0,337.669,91.207Z'
          transform='translate(-295.893 -56.535)'
          fill='#dc0132'
        />
        <path
          id='Path_82'
          data-name='Path 82'
          d='M338.508,102.29l-.177-.273-.008-.013a3.6,3.6,0,0,0-.516-.8c-.165-.156-.212-.111-.225-.077a.114.114,0,0,1-.036.049l-.875.707a.121.121,0,0,1-.076.027h-.453a.121.121,0,0,0-.086.035l-.364.364a.121.121,0,0,0,0,.172l.364.364a.121.121,0,0,0,.086.035h2.281a.121.121,0,0,0,.121-.127l-.017-.4A.122.122,0,0,0,338.508,102.29Z'
          transform='translate(-294.444 -66.993)'
          fill='#dc0132'
        />
        <path
          id='Path_83'
          data-name='Path 83'
          d='M38.8,33.214a5.582,5.582,0,1,1-3.947,1.635A5.582,5.582,0,0,1,38.8,33.214M38.8,32a6.8,6.8,0,1,0,6.8,6.8A6.8,6.8,0,0,0,38.8,32Z'
          fill='#dc0132'
        />
      </g>
    </g>
  </SvgIcon>
);

export default WorldwideService;
